import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import Head from 'next/head'

export type PageMetaProps = {
  title: string
  description?: string
  canonical?: string
  image?: string | null
  siteName?: string
  type?: 'article' | 'website'
  robots?: string
  articlePublishedTime?: string
}

const PageMeta: FC<PageMetaProps, null> = ({
  title,
  description,
  canonical,
  image,
  siteName,
  type = 'website',
  robots,
  articlePublishedTime,
}) => {
  const ctx = useUserContext()
  const resolvedSiteName = siteName ?? ctx?.theme.title
  const resolvedImage =
    image === undefined && ctx?.theme.hostType === 'sellmonitor'
      ? `${ctx.theme.canonicalURL}/next/img/landing/sellmonitor_share.png`
      : image

  return (
    <Head>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      {resolvedSiteName && <meta property="og:site_name" content={resolvedSiteName} />}
      {robots && <meta name="robots" content={robots} />}
      {canonical && (
        <>
          <meta property="og:url" content={canonical} />
          <link rel="canonical" href={canonical} />
        </>
      )}
      {resolvedImage && <meta property="og:image" content={resolvedImage} />}
      {articlePublishedTime && (
        <meta property="article:published_time" content={articlePublishedTime} />
      )}
    </Head>
  )
}

export default PageMeta
